import { createFileRoute } from "@tanstack/react-router";
import { SessionPaymentResult } from "@/components/booking/SessionPaymentResult";
import { parseSessionReturn } from "@/lib/payment-return-url";

// Monri return URL of a therapist-created hold paid through the finalize link.
// The hold token lets a declined payment link straight back to the pay page.
// The query string belongs to Monri and is ignored.
export const Route = createFileRoute("/booking/payment-result/$outcome/$session/$token")({
  component: HoldPaymentReturn,
});

function HoldPaymentReturn() {
  const { outcome, session, token } = Route.useParams();
  return <SessionPaymentResult {...parseSessionReturn({ outcome, session, token })} />;
}
